const FaviconModel = {};

FaviconModel.DEFAULT = {
  id: 1,
  title: 'SkyCoach', // дефолтный тайтл для лк
};

FaviconModel.NEW_MESSAGE = {
  id: 2,
  title: 'New message',
};

FaviconModel.ID_TO_DATA = {
  [FaviconModel.DEFAULT.id]: FaviconModel.DEFAULT,
  [FaviconModel.NEW_MESSAGE.id]: FaviconModel.NEW_MESSAGE,
};

export default FaviconModel;
